import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import VotePrefBase from 'components/interactive/votePref/VotePrefBase'
import DrawerItem from './menu-drawer-item'
import {CloseIcon, Logo} from 'components/static/icons'
import {Link} from 'react-router-dom'
import styled from 'styled-components'
import './menu.css'


const DrawerPosition = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  background: linear-gradient(-45deg, #ddd, #eee);
  background-color:azure;
  z-index: 6;
`


const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  background-color: #333;
`;

const More = styled.h4`
  width: 100%;
  color: white;
  padding-left: 20px;
`;

const CloseWrapper = styled.div`
  width: 20px;
  height: 20px;
  padding-right: 20px;
  cursor: pointer;
`;

const LogoWrapper = styled.div`
  margin-top: 35px;
  height: 40px;
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
`
const LogoutButton = styled.h4`
  display: block;
  margin-top: 20px;
  margin-bottom: 30px;
  padding: 5px 10px;
  border: 2px solid #323232;
  border-radius: 2px;
  cursor: pointer;
  @media not all and (hover: none) {
    &:hover{
      background-color: #323232;
      color: white;
    }
  }
`

class MenuDrawer extends VotePrefBase {
  //-- only works when not using redux
  componentDidMount(){
    this.menu.classList.add('visible');
  }

  handleLogout = () => {
    const { store } = this.context;
    store.dispatch({
      type: "LOGOUT_REQUESTED"
    });
    this.props.toggleVisibility(false);
  }

  render() {
    const isAuthed = this.isAuthed(this.props)//this.props.auth.loggedIn;
    const menuItems = [
      {
        text: 'subscribe',
        to: '/subscribe'
      },
      // {
      //   text: isAuthed ? "My ballot" : "Sign up / login",
      //   to: isAuthed ? "/user" : "/user/register" //-- need to connect this to actually logging out
      // },
      {
        text:"Find your district",
        to:"/find-your-district/"
      },
      {
        text:"Print Guide",
        to:"/print"
      },
      {
        text: "blog",
        to: null,
        link: "https://blog.bythebay.cool/"
      },
      // {
      //   text: "archives",
      //   to: null,
      //   link: 'https://archives.bythebay.cool/'
      // },
      {
        text: "ballot.fyi",
        to: null,
        link:"https://www.ballot.fyi/"
      },
    ];

    const { toggleVisibility } = this.props;
    const items = menuItems.map( (item, i) => (
      <DrawerItem key={i} toggleVisibility={toggleVisibility} text={item.text} to={item.to} link={item.link}/>
    ));
    return(
      <DrawerPosition id='menu-transition' innerRef={(el) => this.menu = el}>
        <InnerContainer>
          <div>
            <TopBar>
              <More>More things to see</More>
              <CloseWrapper onClick={()=>{toggleVisibility(false)}}>
                <CloseIcon color='#fff'/>
              </CloseWrapper>
            </TopBar>
            {items}
            <Link to='/' onClick={()=>{toggleVisibility(false)}}>
              <LogoWrapper><Logo color='#fff'/></LogoWrapper>
            </Link>
          </div>
          {isAuthed &&
            <LogoutButton onClick={this.handleLogout}>
              logout
            </LogoutButton>
          }
        </InnerContainer>
      </DrawerPosition>
    )
  }
}

MenuDrawer.propTypes = {
  toggleVisibility: PropTypes.func.isRequired,
}

MenuDrawer.contextTypes = {
  store: PropTypes.object
};

function mapStateToProps(state) {
  const {auth, user} = state;
  return { auth, user };
}

export default connect(mapStateToProps, {})(withRouter(MenuDrawer));

// export default MenuDrawer;



// WEBPACK FOOTER //
// ./src/components/interactive/menu/menu-drawer.js